import { Pipe, PipeTransform } from "@angular/core";
import { BlockCollectionTypes } from "../../app/api/common/model-enums/block-collection-types.enum";
import { ItemsAccordionBlock } from "../../app/api/packbo/models/items-accordion-block";
import { ItemsAdBlock } from "../../app/api/packbo/models/items-ad-block";
import { ItemsAdLayoutBlock } from "../../app/api/packbo/models/items-ad-layout-block";
import { ItemsAdPackagesBlock } from "../../app/api/packbo/models/items-ad-packages-block";
import { ItemsBronzeSubscriptionFormBlock } from "../../app/api/packbo/models/items-bronze-subscription-form-block";
import { ItemsConfirmationBlock } from "../../app/api/packbo/models/items-confirmation-block";
import { ItemsContactFormBlock } from "../../app/api/packbo/models/items-contact-form-block";
import { ItemsFundingBlock } from "../../app/api/packbo/models/items-funding-block";
import { ItemsHeaderBlock } from "../../app/api/packbo/models/items-header-block";
import { ItemsLandingPageSplitBlock } from "../../app/api/packbo/models/items-landing-page-split-block";
import { ItemsPackageBlock } from "../../app/api/packbo/models/items-package-block";
import { ItemsPartnerBlock } from "../../app/api/packbo/models/items-partner-block";
import { ItemsProductCategoriesBlock } from "../../app/api/packbo/models/items-product-categories-block";
import { ItemsResourceBlock } from "../../app/api/packbo/models/items-resource-block";
import { ItemsRitchtextBlock } from "../../app/api/packbo/models/items-ritchtext-block";
import { ItemsSupplierShowcaseBlock } from "../../app/api/packbo/models/items-supplier-showcase-block";
import { sanitizeDirectusObject } from "../utils/sanitize-directus-object";

type BlockItemTypes =
    | ItemsHeaderBlock
    | ItemsLandingPageSplitBlock
    | ItemsProductCategoriesBlock
    | ItemsSupplierShowcaseBlock
    | ItemsAdLayoutBlock
    | ItemsAdBlock
    | ItemsAccordionBlock
    | ItemsRitchtextBlock
    | ItemsPartnerBlock
    | ItemsFundingBlock
    | ItemsResourceBlock
    | ItemsContactFormBlock
    | ItemsConfirmationBlock
    | ItemsPackageBlock
    | ItemsAdPackagesBlock
    | ItemsBronzeSubscriptionFormBlock;

@Pipe({
    name: "castBlockItem"
})
export class CastBlockItemPipe implements PipeTransform {
    public transform(blockItem: unknown, collection: BlockCollectionTypes): BlockItemTypes | null {
        const sanitizedItem = sanitizeDirectusObject(blockItem);

        if (!sanitizedItem) {
            return null;
        }

        switch (collection) {
            case BlockCollectionTypes.HEADER_BLOCK:
                return sanitizedItem as ItemsHeaderBlock;
            case BlockCollectionTypes.LANDING_PAGE_SPLIT_BLOCK:
                return sanitizedItem as ItemsLandingPageSplitBlock;
            case BlockCollectionTypes.PRODUCT_CATEGORIES_BLOCK:
                return sanitizedItem as ItemsProductCategoriesBlock;
            case BlockCollectionTypes.SUPPLIER_SHOWCASE_BLOCK:
                return sanitizedItem as ItemsSupplierShowcaseBlock;
            case BlockCollectionTypes.AD_LAYOUT_BLOCK:
                return sanitizedItem as ItemsAdLayoutBlock;
            case BlockCollectionTypes.PARTNER_BLOCK:
                return sanitizedItem as ItemsPartnerBlock;
            case BlockCollectionTypes.AD_BLOCK:
                return sanitizedItem as ItemsAdBlock;
            case BlockCollectionTypes.ACCORDION_BLOCK:
                return sanitizedItem as ItemsAccordionBlock;
            case BlockCollectionTypes.RITCHTEXT_BLOCK:
                return sanitizedItem as ItemsRitchtextBlock;
            case BlockCollectionTypes.FUNDING_BLOCK:
                return sanitizedItem as ItemsFundingBlock;
            case BlockCollectionTypes.RESOURCE_BLOCK:
                return sanitizedItem as ItemsResourceBlock;
            case BlockCollectionTypes.CONTACT_FORM_BLOCK:
                return sanitizedItem as ItemsContactFormBlock;
            case BlockCollectionTypes.CONFIRMATION_BLOCK:
                return sanitizedItem as ItemsConfirmationBlock;
            case BlockCollectionTypes.PACKAGE_BLOCK:
                return sanitizedItem as ItemsPackageBlock;
            case BlockCollectionTypes.AD_PACKAGES_BLOCK:
                return sanitizedItem as ItemsAdPackagesBlock;
            case BlockCollectionTypes.BRONZE_SUBSCRIPTION_FORM_BLOCK:
                return sanitizedItem as ItemsBronzeSubscriptionFormBlock;
            default:
                return sanitizedItem as BlockItemTypes;
        }
    }
}
